import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseCollectionResult } from '@hooks/dashboard/useCollection'
import { HYGIENE_PLACEHOLDER } from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTileItem } from '../../FinanceMetricTiles.component'
import { dashboardFinanceMetricFooter } from '../shared/dashboardFinanceMetricFooter'

type CollectionRateMetricCardProps = {
  titleHref: string
  collection: UseCollectionResult
}

export function CollectionRateMetricCard({
  titleHref,
  collection,
}: CollectionRateMetricCardProps): React.ReactElement {
  const {
    loading,
    hasPayload,
    hasRateData,
    summary,
    rateStr,
    collectionRateTargetLabel: targetLabel,
  } = collection
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasRateData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Collection rate"
      titleHref={titleHref}
      className="dashboard-finance-metric-card"
      loading={pending}
      skeleton={{ metrics: 1, block: 'none' }}
      isEmpty={isEmpty}
    >
      <FinanceMetricTileItem
        leftLabel="% of production collected"
        value={loading ? HYGIENE_PLACEHOLDER : rateStr}
        rightLabel={targetLabel}
        footer={
          summary
            ? dashboardFinanceMetricFooter(summary.collectionRate)
            : undefined
        }
      />
    </DashboardSectionCard>
  )
}
